import { MultiValue, SingleValue } from "react-select";
import { ISelectCarmaOption } from "../types";

export const isSingleSelectOption = (
  value: SingleValue<ISelectCarmaOption> | MultiValue<ISelectCarmaOption>
): value is ISelectCarmaOption => Boolean(value) && !Array.isArray(value);
